<!-- eslint-disable -->
<template lang="pug">
    .grade-box
        svg-icon.grade-box__icon(name="calendar", size="large")
        .grade-box__info
            .grade-box__name
                | {{ grade.name }}
            .grade-box__course
                | {{ grade.course.name }}
            .grade-box__timetable
                div(v-for="schedule in grade.timetable")
                    | {{ [schedule.day.toString(), "E"] | moment('dd') }} {{ schedule.time }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            grade: {
                type: Object,
                default: {}
            }
        },
    }
</script>

<style lang="scss" scoped>
    .grade-box {
        display: flex;
        box-sizing: border-box;
        padding: 30px 0;
    }

    .grade-box__icon {
        color: $hsl-color-blue-56;
        margin-right: 15px;
    }

    .grade-box__info {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: $x-color-black;
    }

    .grade-box__timetable {
        font-weight: normal;
    }
</style>
